module.exports = __webpack_public_path__ + "img/book-open.314934ed.svg";